import React, { useCallback } from 'react'
import { getActionLabel } from './utils'

const ActionButton = ({
  label,
  onSelect,
  background,
  isBest,
  percentage,
  userAnswer,
}) => {
  return (
    <div
      onClick={onSelect}
      style={{
        background,
        border: '1.4375px solid rgba(86, 97, 132, 0.2)',
        boxShadow: '0px 2.875px 5.75px rgba(25, 26, 30, 0.4)',
        borderRadius: '10px',
        display: 'flex',
        width: '45%',
        minWidth: '142px',
        fontSize: '16px',
        padding: '10px',
        cursor: 'pointer',
      }}
    >
      <div style={{ textAlign: 'center', fontSize: '17px', width: '100%', color: 'white', textTransform: 'capitalize' }}>
        {getActionLabel(label).toLowerCase()} {userAnswer.answer && `${percentage || 0}%`}
      </div>
    </div>
  )
}

const UserAnswers = ({
  userAnswer,
  handActionsData,
  calculateAnswer,
  availableActions,
}) => {
  const getIsBest = useCallback(
    (answer) => {
      const values = Object.values(handActionsData)
      const answers = Object.keys(handActionsData)
      const bestAnswerIndex = values.reduce(
        (iMax, x, i, arr) => (x > arr[iMax] ? i : iMax),
        0,
      )
      const bestAnswer = answers[bestAnswerIndex]

      return bestAnswer === answer
    },
    [handActionsData],
  )

  const getAnswerBackground = useCallback(
    (answer, isBest) => {
      if (!userAnswer.answer) return 'linear-gradient(to bottom, #7C8B97, #313E47)'

      if (userAnswer.answer === answer) {
        if (isBest) return 'linear-gradient(to bottom, #16CF61, #0C7B39)'
        if (userAnswer.points >= 5)  return 'linear-gradient(to bottom, #F08A13, #FFC700)'
        return '#E81320'
      } else {
        if (isBest && userAnswer.points !== 10) return 'linear-gradient(to bottom, #16CF61, #0C7B39)'
        return 'linear-gradient(to bottom, #7C8B97, #313E47)'
      }
    },
    [userAnswer],
  )

  return Object.keys(handActionsData).map((action) => {
    const isBest = getIsBest(action)
    const percentage = Math.round(handActionsData[action] * 100)
    const background = getAnswerBackground(action, isBest)
    return (
      <ActionButton
        isBest={isBest}
        percentage={percentage}
        background={background}
        onSelect={() => calculateAnswer(action)}
        label={action}
        userAnswer={userAnswer}
      />
    )
  })
}

export default UserAnswers
